module.exports = __webpack_public_path__ + "img/SK31634419.6f206c81.svg";